import { ApolloError, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';
import { Interval, toDate } from 'date-fns';
import { DeviceTimeSeries, DeviceTimeSeriesQuery, DeviceTimeSeriesQueryVariables } from 'generated/graphql';
import gql from 'graphql-tag';

const deviceTimeSeriesQuery: TypedDocumentNode<DeviceTimeSeriesQuery, DeviceTimeSeriesQueryVariables> = gql`
  query DeviceTimeSeries($deviceNumbers: [ID!]!, $interval: IntervalInput!) {
    deviceTimeSeries(deviceNumbers: $deviceNumbers, interval: $interval) {
      id
      deviceNumber
      datapoints {
        date
        energyCapabilityPos
        energyCapabilityNeg
        actualPower
      }
    }
  }
`;

export function useDeviceTimeSeries(
  deviceNumbers: readonly string[],
  interval: Interval,
): [readonly DeviceTimeSeries[] | undefined, ApolloError | undefined] {
  const { data, error } = useSuspenseQuery(deviceTimeSeriesQuery, {
    variables: {
      deviceNumbers,
      interval: {
        start: toDate(interval.start),
        end: toDate(interval.end),
      },
    },
    errorPolicy: 'all',
  });

  return [data?.deviceTimeSeries, error];
}
